import { getCurrentLocale } from '../fhg/components/app/BasicApp'
import config from './runtime'

// Initialize the locale to the browser's current locale
const locale = getCurrentLocale()

// Load messages based on locale and environment
let messages
try {
    const allMessages = require(`../messages/${locale}`)
    if (config.ENVIRONMENT === 'purplewave.net') {
        const otherMessages = require(`../messages/purple_wave/${locale}`)
        messages = { ...allMessages, ...otherMessages }
    } else {
        messages = allMessages
    }
} catch (e) {
    const allMessages = require('../messages/en-US')
    if (config.ENVIRONMENT === 'purplewave.net') {
        const otherMessages = require('../messages/purple_wave/en-US')
        messages = { ...allMessages, ...otherMessages }
    } else {
        messages = allMessages
    }
}

export { locale, messages }